export const SET_OPTION = 'SET_OPTION';
export const TOGGLE_OPTION = 'TOGGLE_OPTION';

export const MUSIC_VOLUME = 'MUSIC_VOLUME';
export const MUSIC_MUTED = 'MUSIC_MUTED';

export const SOUND_EFFECTS_VOLUME = 'SOUND_EFFECTS_VOLUME';
export const SOUND_EFFECTS_MUTED = 'SOUND_EFFECTS_MUTED';
export const SESSION_NAME = 'SESSION_NAME';

// Actions
export const setOption = (prop, value) => {
  return {
    type: SET_OPTION,
    prop,
    value,
  };
};

export const toggleOption = (prop) => ({
  type: TOGGLE_OPTION,
  prop,
});

// Selectors
export const getOption = (prop) => (state) => state.options[prop];

// Reducer
const INITIAL_STATE = {
  [MUSIC_VOLUME]: 80,
  [MUSIC_MUTED]: false,
  [SOUND_EFFECTS_MUTED]: false,
  [MUSIC_VOLUME]: 80,
  [SESSION_NAME]: '',
};

const options = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_OPTION:
      return {
        ...state,
        [action.prop]: action.value,
      };
    case TOGGLE_OPTION:
      return {
        ...state,
        [action.prop]: !state[action.prop],
      };
    default:
      return state;
  }
};

export default options;
